import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { updateVesselOrder } from 'actions/vessels/orders';

const typeTerms = [
    'Direction dets:',
    'Cargo dets:',
    'Period dets:',
    'Other:',
];

class Terms extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
        };

        this.onChangeTerm = this.onChangeTerm.bind(this);
        this.addNewTerm = this.addNewTerm.bind(this);
        this.removeTerm = this.removeTerm.bind(this);
        this.showError = this.showError.bind(this);
        this.onChangeTypeTerm = this.onChangeTypeTerm.bind(this);
    }

    removeTerm(number) {
        this.deleteError(number);
        const newVesselOrder = _.cloneDeep(this.props.vesselOrder);
        newVesselOrder.terms.splice(number, 1);
        this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
    }

    addNewTerm() {
        const newVesselOrder = _.cloneDeep(this.props.vesselOrder);
        newVesselOrder.terms.push({ type: '', value: '' });
        this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
    }

    onChangeTypeTerm(key, numberElement) {
        const newVesselOrder = _.cloneDeep(this.props.vesselOrder);
        newVesselOrder.terms[numberElement].type = typeTerms[key];
        this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
    }

    onChangeTerm(value, numberElement) {
        const newVesselOrder = _.cloneDeep(this.props.vesselOrder);
        newVesselOrder.terms[numberElement].value = value;
        this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        /*
        if (newProps.validateErrors && newProps.validateErrors.length) {
            const errors = [];
            newProps.validateErrors.forEach((validateError) => {
                const typeError = validateError.field.split('.');

                if (typeError[0] === 'terms') {
                    errors.push({ key: +typeError[2], text: validateError.messages[0] });
                }
            });

            this.setState({
                errors,
            });
        }*/
    }

    deleteError(key) {
        const errors = this.state.errors.filter((error) => {
            return error.key !== key;
        });

        this.setState({
            errors,
        });
    }

    showError(key) {
        const errorObject = this.state.errors.find((error) => {
            return error.key === key;
        });

        return errorObject ? errorObject.text : '';
    }

    render() {
        return (
            <div>
                <div className='row'>
                    <div className='column-left'>
                        Terms:
                    </div>
                    <div className='column-right'>
                        <RaisedButton
                            labelStyle={{ fontSize: '10px' }}
                            style={{ height: '25px' }}
                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            label='Add new term'
                            onClick={this.addNewTerm}
                            primary
                        />
                    </div>
                </div>
                {
                    this.props.vesselOrder.terms.map((term, key) => {
                        const errorMessage = this.showError(key);
                        return (
                            <div key={key} className='row'>
                                <div className='column-left'>
                                    {`Term ${key}`}
                                </div>
                                <div className='column-right'>
                                    <SelectField
                                        style={{
                                            padding: '0 5px',
                                            width: '80%',
                                            fontSize: '13px',
                                        }}
                                        defaultValue={term.type}
                                        value={term.type}
                                        onChange={(e, numberSelected) => {
                                            this.onChangeTypeTerm(numberSelected, key);
                                        }}
                                        maxHeight={200}
                                        autoWidth
                                    >
                                        {
                                            typeTerms.map((typeTerm, i) => {
                                                return (<MenuItem
                                                    key={i}
                                                    style={{ width: 'auto', fontSize: '13px' }}
                                                    value={typeTerm}
                                                    primaryText={typeTerm}
                                                />);
                                            })
                                        }
                                    </SelectField>
                                    <TextField
                                        style={{ fontSize: '13px' }}
                                        value={term.value}
                                        hintText={`Term ${key}`}
                                        errorText={errorMessage}
                                        onChange={(e) => { return this.onChangeTerm(e.target.value, key); }}
                                    />
                                    <RaisedButton
                                        labelStyle={{ fontSize: '10px' }}
                                        style={{ height: '25px' }}
                                        buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                        label='Remove term'
                                        onClick={() => { return this.removeTerm(key); }}
                                        secondary
                                    />
                                </div>
                            </div>);
                    })
                }
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        return {
            numberOrderTable: ownProps.numberOrderTable,
            validateErrors: state.vesselOrders.items[ownProps.numberOrderTable].validateErrors,
            vesselOrder: state.vesselOrders.items[ownProps.numberOrderTable],
        };
    },
    dispatch => bindActionCreators({
        updateVesselOrder,
    }, dispatch),
)(Terms);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Vessel/Sidebar/Order/Terms.jsx